import { render, staticRenderFns } from "./shopping-section.vue?vue&type=template&id=ae840d8c&scoped=true"
import script from "./shopping-section.vue?vue&type=script&lang=js"
export * from "./shopping-section.vue?vue&type=script&lang=js"
import style0 from "./shopping-section.vue?vue&type=style&index=0&id=ae840d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae840d8c",
  null
  
)

export default component.exports